import { LoaderOverlay } from '@common-components';
import { BrandingMode } from 'enums';
import { Submission } from 'types';
import WithRouteLocationState from 'broker/components/WithRouteLocationState';
import { RouteKey } from 'broker/enums';
import { useBrandConfigByMode } from 'broker/pages/SubmissionWorkspacePage/contexts/BrandConfigProvider';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import Content from './Content';
import { FlowBinderLocationState } from './utils';

interface FlowBinderWithLocationStateProps {
  locationState: FlowBinderLocationState;
  submission: Submission;
}

function FlowBinderContent({ locationState, submission }: FlowBinderWithLocationStateProps) {
  const { brandConfig, isLoading } = useBrandConfigByMode(locationState.brandingMode || BrandingMode.Organization);

  if (isLoading || !brandConfig) {
    return <LoaderOverlay hideOverlay />;
  }
  return <Content locationState={locationState} submission={submission} brandConfig={brandConfig} />;
}

export default function FlowBinder() {
  const { submission } = useSubmissionsWorkspace();

  if (!submission) {
    return null;
  }

  return (
    <WithRouteLocationState routeKey={RouteKey.FlowBinder} isStateRequired>
      {(locationState) => <FlowBinderContent locationState={locationState} submission={submission} />}
    </WithRouteLocationState>
  );
}
